import React, { useCallback, useState } from 'react';

import { Panel, PanelSection, PanelSectionLayout } from '@mpm-druid/types';
import { DashboardSections } from './DashboardSection';
import { PanelGrid } from './PanelGrid';
import { PanelModal } from './PanelModal';
import { useModelViewStore } from './modelViewStore';

import styles from './DashboardPage.module.scss';

export function DashboardContent() {
  const sections = useModelViewStore(state => state.view.data.sections);
  const updateView = useModelViewStore(state => state.updateView);

  const [panelModalSectionId, setPanelModalSectionId] = useState<string | null>(
    null
  );

  const handleAddItemClick = useCallback((id: string) => {
    setPanelModalSectionId(id);
  }, []);

  const handleSectionsChange = useCallback(
    (sections: PanelSection[]) => {
      updateView({ data: { sections } });
    },
    [updateView]
  );

  const renderSectionItems = useCallback(
    (sectionId: string, items: Panel[], layout: PanelSectionLayout) => {
      return <PanelGrid layout={layout} panels={items} sectionId={sectionId} />;
    },
    []
  );

  return (
    <div className={styles.dashboardContent}>
      <DashboardSections
        onAddItemClick={handleAddItemClick}
        onSectionsChange={handleSectionsChange}
        renderSectionItems={renderSectionItems}
        sections={sections}
      />

      {panelModalSectionId ? (
        <PanelModal
          onClose={() => setPanelModalSectionId(null)}
          sectionId={panelModalSectionId}
        />
      ) : null}
    </div>
  );
}
